export const mockHeldValidationSubmissionsResponse = {
  data: [
    {
      id: 'staging_validationsubmission_000000DQhold0000000000000001',
      receivedAt: '2026-10-24T09:12:03.000Z',
      heldAt: '2026-10-24T09:22:05.000Z',
      assessment: {
        verdict: 'wave',
        assessor: 'wave-detector',
        evidence: { current: 40, baseline: 4 },
        assessedAt: '2026-10-24T09:22:05.000Z'
      },
      partner: { id: 'staging_partner_000000CjaJGNpAvupsC4sHbLztaHQ', name: 'Hootsuite' },
      configuration: { id: 'staging_hostedconfiguration_000000D35QK4yGqSWcx2uUpXkP7oH', name: 'Hootsuite for Good' },
      submission: {
        firstName: 'Ada',
        lastName: 'Lovelace',
        email: 'ada@example.org',
        countryCode: 'GBR',
        status: 'pending'
      }
    }
  ],
  object: 'admin/validation-submission-holds',
  pageSize: 25,
  totalResults: 1,
  _links: {
    current: 'https://staging-api.poweredbypercent.com/v1/admin/validation-submissions/holds'
  }
}
